import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { articles } from "../utils/articles";

/**
 * Renvoie vers les guides du blog depuis les pages de service.
 *
 * Les articles n'avaient qu'un seul lien entrant chacun, celui de la liste
 * /blog : un article que rien ne pointe depuis une page de fond est traité
 * comme secondaire par les moteurs, et un visiteur ne le croise jamais.
 * Ce bloc les rattache à la page qui traite du même sujet.
 */
const GuidesLies = ({ slugs = [], titre = "Pour aller plus loin" }) => {
  const choisis = slugs
    .map((s) => articles.find((a) => a.slug === s))
    .filter(Boolean);

  if (!choisis.length) return null;

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-2xl font-bold text-gray-900 mb-8 flex items-center gap-3">
            <BookOpen className="h-6 w-6 text-orange-700" aria-hidden="true" />
            {titre}
          </h2>

          <ul className="grid md:grid-cols-2 gap-4">
            {choisis.map((a) => (
              <li key={a.slug}>
                <Link
                  to={`/blog/${a.slug}`}
                  className="group block h-full rounded-lg border-2 border-gray-200 bg-white p-5 transition-colors hover:border-orange-700 hover:bg-orange-50"
                >
                  <span className="block font-semibold text-gray-900 group-hover:text-orange-800">
                    {a.titre}
                  </span>
                  {a.resume && (
                    <span className="mt-2 block text-sm text-gray-700">
                      {a.resume.length > 130
                        ? `${a.resume.slice(0, 130)}…`
                        : a.resume}
                    </span>
                  )}
                  <span className="mt-3 inline-flex items-center text-sm font-medium text-orange-700">
                    Lire le guide
                    <ArrowRight
                      className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-1"
                      aria-hidden="true"
                    />
                  </span>
                </Link>
              </li>
            ))}
          </ul>

          <p className="mt-6">
            <Link
              to="/blog"
              className="inline-flex items-center font-medium text-orange-700 underline hover:text-orange-800"
            >
              Voir tous les guides MaPrimeAdapt&apos;
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default GuidesLies;
